import * as React from "react";

import placeholderImg from "assets/svg/settings/cards.svg";
import { NoMobileScreen } from "components/mobile/NoMobileScreen";

const NoMobile: React.FC = () => (
  <NoMobileScreen
    icon={placeholderImg}
    description={
      <>
        <strong>Apps and integrations</strong> are not available on mobile devices. Please switch to a desktop browser
        for a better experience.
      </>
    }
  />
);

export default NoMobile;
